<script setup lang="ts">
import { ref, onMounted, onUnmounted, watch } from 'vue'
import 'altcha/i18n/fr-fr'

const props = defineProps({
  payload: {
    type: String,
    required: false,
    default: '',
  },
})

const emit = defineEmits<{
  (e: 'update:payload', value: string): void
}>()

const isBrowser = ref(false)
const internalValue = ref(props.payload)
const challengeUrl = new URL('/meiaapi/captcha/challenge', import.meta.env.PUBLIC_ENV__APIGEE_URL)

watch(internalValue, (v) => {
  if (v !== props.payload) {
    emit('update:payload', v || '')
  }
})

onMounted(async () => {
  isBrowser.value = typeof window !== 'undefined'

  if (isBrowser.value) {
    try {
      await import('altcha')
      const altchaElement = document.querySelector('#altcha')
      if (altchaElement) {
        altchaElement?.addEventListener('statechange', onStateChange)
      } else {
        console.error('Element #altcha non trouvé dans le DOM')
      }
    } catch (error) {
      console.error('Erreur lors du chargement de Altcha :', error)
    }
  }
})

onUnmounted(() => {
  document.querySelector('#altcha')?.removeEventListener('statechange', onStateChange)
})

const onStateChange = (event: CustomEvent | Event) => {
  if ('detail' in event) {
    const { payload, state } = event.detail
    if (state === 'verified' && payload) {
      internalValue.value = payload
    } else {
      internalValue.value = ''
    }
  }
}

globalThis.altchaI18n.set('fr-fr', {
  ...globalThis.altchaI18n.get('fr-fr'),
  label: 'Je ne suis pas un robot.', // Custom label
})
</script>

<template>
  <altcha-widget
    id="altcha"
    language="fr-fr"
    :challengeurl="challengeUrl"
    disablerefetchonexpire
    hidefooter
    hidelogo
  />
</template>
